var e=3e4,r=6e4,a=6e4;export{r as GEOLOCATION_MAXIMUM_AGE,e as GEOLOCATION_TIMEOUT,a as GEOLOCATION_UPDATE_INTERVAL};
//# sourceMappingURL=useGeolocation.constants.js.map
